import { Navigate, Route, Routes } from "react-router-dom";

import "./App.css";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import Footer from "./components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import Courses from "./pages/Courses/Courses";
import CourseDetail from "./pages/CourseDetail/CourseDetail";
import AboutUs from "./pages/About/AboutUs";
import ContactUs from "./pages/Contact/ContactUs";
import HomePage from "./pages/Home/HomePage";
import Popular from "./pages/Popular/Popular";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import RequestProposal from "./pages/RequestProposal/RequestProposal";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";

function Layout({ children }) {
  return (
    <div className="app-shell">
      <Navbar onRequestProposal={() => {}} />
      {children}
      <Footer onCourseFilter={() => {}} />
      <CookieBanner />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/courses" element={<Layout><Courses /></Layout>} />
      <Route path="/courses/:courseSlug" element={<Layout><CourseDetail /></Layout>} />
      <Route path="/about" element={<Layout><AboutUs /></Layout>} />
      <Route path="/popular" element={<Layout><Popular /></Layout>} />
      <Route path="/contact" element={<Layout><ContactUs /></Layout>} />
      <Route path="/request-proposal" element={<Layout><RequestProposal /></Layout>} />
      <Route path="/terms-and-conditions" element={<Layout><TermsAndConditions /></Layout>} />
      <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
